import React from 'react'
import { Box, Popover, Typography, makeStyles, Theme } from '@material-ui/core'
import {
    Event as EventIcon,
    DirectionsWalk as TourIcon,
} from '@material-ui/icons'

const useStyles = makeStyles((theme: Theme) => ({
    paper: {
        borderRadius: 12,
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        overflow: 'hidden',
        minWidth: 200,
    },
    option: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        padding: theme.spacing(1.5, 2),
        cursor: 'pointer',
        transition: 'background-color 0.15s',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
    optionIcon: {
        fontSize: 20,
        color: theme.palette.text.secondary,
    },
    optionLabel: {
        fontWeight: 600,
        fontSize: '0.875rem',
    },
    divider: {
        height: 1,
        backgroundColor: theme.palette.divider,
        margin: 0,
    },
}))

interface Props {
    anchorPosition: { top: number; left: number } | null
    onClose: () => void
    onSelectEvent: () => void
    onSelectTour: () => void
}

export const DateClickPopover: React.FC<Props> = ({
    anchorPosition,
    onClose,
    onSelectEvent,
    onSelectTour,
}) => {
    const classes = useStyles()

    return (
        <Popover
            open={!!anchorPosition}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={anchorPosition ?? undefined}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            PaperProps={{ className: classes.paper }}
        >
            <Box
                className={classes.option}
                onClick={() => {
                    onClose()
                    onSelectEvent()
                }}
            >
                <EventIcon className={classes.optionIcon} />
                <Typography className={classes.optionLabel}>
                    Property Event
                </Typography>
            </Box>
            <div className={classes.divider} />
            <Box
                className={classes.option}
                onClick={() => {
                    onClose()
                    onSelectTour()
                }}
            >
                <TourIcon className={classes.optionIcon} />
                <Typography className={classes.optionLabel}>
                    Schedule Tour
                </Typography>
            </Box>
        </Popover>
    )
}
